'use strict';

angular.module('amexReconciliationApp')
  .component('advancedSearchCheckboxFields', {
    templateUrl: 'scripts/views/components/advanced-search-checkbox-fields.html',
    bindings: {
      criterion: '=',
      fieldList: '<'
    },
    controller: function() {
      var self = this;

      self.toggleSelection = function (field) {
        var fieldValues = self.criterion.fieldValue.values;
        if (self.isSelected(field)) {
          _.pull(fieldValues, field);
        } else {
          fieldValues.push(field);
        }
      };

      self.isSelected = function(field) {
        return _.includes(self.criterion.fieldValue.values, field);
      };
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/advancedSearchCheckboxFields.js
// module id = 430
// module chunks = 0